import React, { useContext, useEffect, useState } from "react";
import { CORPORATION } from "@/constants";

const GlobalContext = React.createContext();
const GlobalContextUpdate = React.createContext(null);

export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
export const useGlobalContextUpdate = () => {
  return useContext(GlobalContextUpdate);
};

let store = {};

export const GlobalContextWrapper = ({ children }) => {
  const [globalContextValue, setGlobalContextValue] = useState({
    showOverlay: false,
    showNotification: false,
    isModalOpen: false,
    notificationType: "",
    notificationMessage: "",
    corporation: CORPORATION.SENADO,
    modalContent: "",
    modalColor: "",
    data: {},
  });

  useEffect(() => {
    store = globalContextValue;
  }, [globalContextValue]);

  window.getGlobalContext = () => globalContextValue;

  const updateContext = (value = {}) => {
    const result = { ...store, ...value };
    setGlobalContextValue(result);
  };

  return (
    <GlobalContext.Provider value={globalContextValue}>
      <GlobalContextUpdate.Provider value={updateContext}>
        {children}
      </GlobalContextUpdate.Provider>
    </GlobalContext.Provider>
  );
};
